import React from 'react'
import { useLocation } from 'react-router-dom'
import { useAppSelector } from '../../BusinessObjects/Redux/app/hook'
import { RootState } from '../../BusinessObjects/Redux/app/store'
import { RoutePath } from '../../Utils/RoutePath'
import './Footer.css'

type Props = {}

const Footer = (props: Props) => {

    let location = useLocation()

    const isLoggedIn = useAppSelector((state: RootState) => state.user.isLoggedIn)

    if (location.pathname === RoutePath.LOGIN) {
        return (
            <footer className="text-center text-lg-start mt-auto py-3 border-top">
                <div className="text-center p-3">
                    © Copyright E-CUBE {new Date().getFullYear()}
                </div>
            </footer>
        )
    }

    return <></>
}

export default Footer